import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ChallengeService } from "app/views/challenge/challenge.service";
import { Observable, Subject } from "rxjs";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
@Component({
  selector: "app-customer-challengeinfo",
  templateUrl: "./challengeinfo.component.html",
  styleUrls: ["./challengeinfo.component.css"],
})
export class CustomerChallengeInfoComponent implements OnInit {
  @Input() customerId: string;
  readyTable = false;

  // Filters and table configuration referenced in template
  public textFilter = KontableComponent.TextFilter;
  public dateFilter = KontableComponent.DateFilter;
  public selectFilter = KontableComponent.SelectFilter;
  public paginationType = KontableComponent.ServerPagination;
  public actions: any[] = [];
  public pageSubject: Subject<any> = new Subject<any>();
  public startDate: Date = null;
  public endDate: Date = null;

  public agreementOptions: any[] = [
    { label: '', value: null },
    { label: 'Sì', value: '1' },
    { label: 'No', value: '0' }
  ];

  public statusOptions: any[] = [
    { label: '', value: null },
    { label: 'challenge.to_accept', value: 'TO_ACCEPT' },
    { label: 'challenge.accepted', value: 'ACCEPTED' },
    { label: 'challenge.ongoing', value: 'ONGOING' },
    { label: 'challenge.won', value: 'WON' },
    { label: 'challenge.ended', value: 'ENDED' }
  ];

  statusColors: { [key: string]: string } = {
    TO_ACCEPT: "red-dot",
    ACCEPTED: "orange-dot",
    ONGOING: "orange-dot",
    WON: "green-dot",
    ENDED: "black-dot"
  };
  statusLabels: {
    TO_ACCEPT: string;
    ACCEPTED: string;
    ONGOING: string;
    WON: string;
    ENDED: string;
  };

  constructor(
    public challengeService: ChallengeService,
    private translateService: TranslateService
  ) {}

  clearDateFields() {
    this.startDate = null;
    this.endDate = null;
  }

  ngOnInit() {
    this.readyTable = true;
    this.initCalledVariable();

    this.translateService.get(['common.yes', 'common.no']).subscribe(res => {
      this.agreementOptions[1].label = res['common.yes'] || 'Sì';
      this.agreementOptions[2].label = res['common.no'] || 'No';
    });
  }
  private initCalledVariable() {
    const STATUS_TO_ACCEPT = this.translateService.get("challenge.to_accept");
    const STATUS_ACCEPTED = this.translateService.get("challenge.accepted");
    const STATUS_ON_GOING = this.translateService.get("challenge.ongoing");
    const STATUS_WON = this.translateService.get("challenge.won");
    const STATUS_ENDED = this.translateService.get("challenge.ended");
    const self = this;
    Observable.zip(
      STATUS_TO_ACCEPT,
      STATUS_ACCEPTED,
      STATUS_ON_GOING,
      STATUS_WON,
      STATUS_ENDED
    ).subscribe(
      ([statusToAccept, statusAccepted, statusOnGoing, statusWon, statusEnded]) => {
        self.statusLabels = {
          TO_ACCEPT: statusToAccept,
          ACCEPTED: statusAccepted,
          ONGOING: statusOnGoing,
          WON: statusWon,
          ENDED: statusEnded
        };
        self.statusOptions[1].label = statusToAccept;
        self.statusOptions[2].label = statusAccepted;
        self.statusOptions[3].label = statusOnGoing;
        self.statusOptions[4].label = statusWon;
        self.statusOptions[5].label = statusEnded;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challengeinfo.component.ts